import { apiClient } from './api';

// Weather service for frontend
export const weatherService = {
    // Get weather data for a specific date
    getWeatherForDate: async (date, coordinates = null) => {
        try {
            const params = { date };

            // Add coordinates if provided
            if (coordinates) {
                params.lat = coordinates.lat;
                params.lon = coordinates.lon;
            }

            const response = await apiClient.get('/betriebstagebuch/weather', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching weather data:', error);

            // Return fallback data on error
            return {
                weather: 'Weather data unavailable',
                temperature: null,
                description: 'Unable to fetch weather data'
            };
        }
    },

    // Get user's current location (if permission granted)
    getCurrentLocation: () => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation is not supported by this browser'));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        lat: position.coords.latitude,
                        lon: position.coords.longitude
                    });
                },
                (error) => {
                    console.warn('Error getting location:', error);
                    reject(error);
                },
                {
                    enableHighAccuracy: false,
                    timeout: 10000,
                    maximumAge: 600000 // Cache for 10 minutes
                }
            );
        });
    }
};
